import { isPlatformBrowser } from '@angular/common'
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject, PLATFORM_ID } from '@angular/core'

import { CookieService } from 'ngx-cookie-service'
import { Observable } from 'rxjs'

export function tokenInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const cookieService = inject(CookieService)
  const platformId = inject(PLATFORM_ID)

  let token = null
  if (isPlatformBrowser(platformId)) {
    const user = localStorage.getItem('user')
    token = user ? JSON.parse(user).token : null
  }

  const storeToken = cookieService.get('token')

  if (token) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    })
  }

  if (storeToken) {
    req = req.clone({
      setHeaders: { 'Storefront-Context': storeToken }
    })
  }

  return next(req)
}
